import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { colors } from '@material-ui/core';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../../components/ModalDialog/ModalDialog.js';
import { DeleteUser } from '../../../../actions/UsersActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const DeleteUserDialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const roles = useSelector((state) => state.usersReducer.roles);
	const openDeleteUserDialogId = useSelector((state) => state.usersReducer.openDeleteUserDialogId);
	const title = 'Delete user';

	const _onConfirmClick = () => {
		dispatch(DeleteUser(openDeleteUserDialogId, rest.user.role));
		dispatch(enqueueSnackbar({ message: 'User deleted', options: { variant: 'info' } }));
	};

	return (
		<ModalDialog
			maxWidth="xs"
			onClose={onClose}
			open={open}
			title={title}
			confirmLabel="Delete"
			onConfirmClicked={_onConfirmClick}
		>
			<p>Are you sure you want to delete this User?</p>
		</ModalDialog>
	);
};

DeleteUserDialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default DeleteUserDialog;
